"use strict";

angular.module('PatientApp').factory('LinkedAccountsService', function (VuexStore) {
  return {
    hasUnverified: function hasUnverified(encounterGroupId, onlyWithNewAccts) {
      return VuexStore.getters.getHasUnverifiedAccountWithEncounterGroupId(encounterGroupId, onlyWithNewAccts);
    },
    getNotificationText: function getNotificationText(encounterGroupId) {
      return VuexStore.getters.getNotificationTextForEncounterGroupId(encounterGroupId);
    },
    getNumberOfNewAccts: function getNumberOfNewAccts(masterLinkId) {
      return this.getNewAcctsSecureCodes(masterLinkId).length;
    },
    getNewAcctsSecureCodes: function getNewAcctsSecureCodes(masterLinkId) {
      return VuexStore.getters.getNewAccountsSecureCodesFromMasterLinkId(masterLinkId);
    },
    getBillToLinkAfterVerify: function getBillToLinkAfterVerify(masterLinkId, scodeWithPayIntent) {
      return VuexStore.getters.getBillToLinkAfterVerifyFromMasterLinkIdAndSecureCode(masterLinkId, scodeWithPayIntent);
    },
    haveAnyMasterLinksBeenVerifiedYet: function haveAnyMasterLinksBeenVerifiedYet() {
      return VuexStore.state.LinkedAccountsStore.haveAnyMasterLinksBeenVerifiedYet;
    },
    getAllUnverified: function getAllUnverified() {
      return VuexStore.state.LinkedAccountsStore.unverifiedAccounts;
    },
    fetchUnverified: function fetchUnverified(forceRefresh) {
      return VuexStore.dispatch('fetchUnverifiedAccounts', forceRefresh);
    },
    authenticateAccount: function authenticateAccount(masterLinkId, fieldOneValue, fieldTwoValue) {
      return VuexStore.dispatch('authenticateAccount', {
        masterLinkId: masterLinkId,
        fieldOneValue: fieldOneValue,
        fieldTwoValue: fieldTwoValue
      });
    }
  };
});